import { ItemList } from "../../orm"

class AdminDatabase extends ItemList {

    getEntityKey() {
        return "admin/database";
    }

}

export const adminDatabaseList = new AdminDatabase("admin_database__default");
